var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w3-content",attrs:{"id":"app"}},[_c('div',{staticClass:"appWrapperw"},[_c('div',{staticClass:"navbarWrapper"},[_c('nav-bar')],1),_c('div',{staticClass:"content w3-main w3-margin-bottom"},[_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }